export class faqLabel {

    quotation: string;
    application: string;
    finance: string;
    help: string;
    covered: string;
    controller: {
        title: string;
        addQue: string;
        quotation: string;
        application: string;
        finance: string;
        edit: string;
        delete: string;
    }
    adder: {
        title: string;
        category: string;
        question: string;
        answer: string;
        applicableto: string;
        submit: string;
        cancel: string;
        dealer: string;
        customer: string;
        both: string;
    }
    deleter: {
        title: string;
        yes: string;
        no: string;
    }
    editor: {
        title: string;
        category: string;
        question: string;
        answer: string;
        applicableto: string;
        submit: string;
        cancel: string;
        dealer: string;
        customer: string;
        both: string;
    }

    constructor() {
        this.quotation = "Quotation Creation";
        this.application = "Application Process";
        this.finance = "Finance Product";
        this.help = "FAQ! Need Help?";
        this.covered = "We've got you covered";
        this.controller = {
            title: "FAQ Add/Edit",
            addQue: "Add Question",
            quotation: "Quotation Creation",
            application: "Application Process",
            finance: "Finance Product",
            edit: "EDIT",
            delete: "DELETE"
        }
        this.adder = {
            title: "Add Appoinment",
            category: "Category",
            question: "Question",
            answer: "Answer",
            applicableto: "Applicable to ",
            submit: "Submit",
            cancel: "Cancel",
            dealer: "Dealer",
            customer: "Customer",
            both: "Both"
        }
        this.deleter = {
            title: "Do you need to Delete the record? ",
            yes: "Yes",
            no: "No"
        }
        this.editor = {
            title: "Edit Appoinment",
            category: "Category",
            question: "Question",
            answer: "Answer",
            applicableto: "Applicable to ",
            submit: "Submit",
            cancel: "Cancel",
            dealer: "Dealer",
            customer: "Customer",
            both: "Both"
        }
    }
}
